import { FC } from 'react';
import CouponCard from '../CouponCard/CouponCard';
import { IOrganizationCoupon } from '../../types/coupons.types';
import './CouponsList.scss';

interface CouponsList {
  coupons?: IOrganizationCoupon[];
  handleDelete: (id: number) => void;
}

const CouponsList: FC<CouponsList> = ({ coupons, handleDelete }: CouponsList) => {
  const availableCoupons = coupons?.filter(coupon => !coupon.usedAt) || [];

  return (
    <div className="couponsList">
      {!!availableCoupons?.length &&
        availableCoupons?.map(coupon => (
          <CouponCard key={coupon?.id} couponData={coupon} handleDelete={handleDelete} />
        ))}

      {!coupons?.length && <div className="noDataMessage">La empresa no tiene cupones asociados</div>}
    </div>
  );
};

export default CouponsList;
